module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "graph-key",
    class: {
      'graph-key__flex': _vm.flex
    }
  }, _vm._l((_vm.graphKeyItems), function(item) {
    return _c('li', {
      staticClass: "graph-key__item"
    }, [(item.color) ? _c('span', {
      staticClass: "graph-key__item-color",
      style: ({
        background: item.color
      })
    }) : _vm._e(), _vm._v("\n    " + _vm._s(item.body) + "\n    "), (item.value) ? _c('span', {
      staticClass: "graph-key__item-value"
    }, [_vm._v(" " + _vm._s(item.value))]) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c5b0ea3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/oldWorkbench/graphKey/GraphKey.vue
// module id = 1889
// module chunks = 0